export const LANGUAGES = ['es', 'en', 'fr', 'de', 'pt'] as const
